import React, { ReactNode } from 'react';
import type { AxiosInstance } from 'axios';
import { AxiosContext } from './AxiosContext';

// Create a provider component
export const AxiosProvider: React.FC<{ instance: AxiosInstance; children: ReactNode }> = ({ instance, children }) => {
    return <AxiosContext.Provider value={instance}>{children}</AxiosContext.Provider>;
};

